<div *ngIf="reportType == 'Monthwise'">
  <div class="container" id="print-section" style="padding: 20px;">
    <table class="table table-bordered" 
           style="width: 100%; table-layout: fixed; border-collapse: collapse; font-size: 10px;">
      <thead>
        <!-- Header Row 1 -->
        <tr style="text-align: center; font-weight: bold;">
          <th colspan="1" style="border: 1px solid #000;">VIVEK SAPTAHIK</th>
          <th colspan="1" style="border: 1px solid #000;">ISSUE SELLER PAYMENT <br> RECEIPT LEDGER</th>
        </tr>

        <!-- Header Row 2 -->
        <tr style="text-align: center;">
          <th colspan="1" style="border: 1px solid #000;">MONTHWISE</th>
          <th colspan="1" style="border: 1px solid #000;">
            DATE FROM: {{ startDate | date: 'dd-MM-yyyy' }}<br>
            TO: {{ endDate | date: 'dd-MM-yyyy' }} <br>PAGE NO
          </th>
          
        </tr>

        <!-- Header Row 3 -->
        <tr style="text-align: center; font-weight: bold;">
          <th colspan="1" style="border: 1px solid #000; width: 50%; white-space: nowrap;">MONTH</th>
          <th colspan="1" style="border: 1px solid #000; width: 50%; white-space: nowrap;">RECEIVEDAMOUNT</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let data of advtMonthwiseFormBeans">
          <td colspan="1" style="border: 1px solid #000; text-align: left; width: 50%; white-space: nowrap;">
            {{ data.month }} - {{ data.year }}
          </td>
          <td colspan="1" style="border: 1px solid #000; text-align: right; width: 50%; white-space: nowrap;">
            {{ data.rcv_amt | number:'1.2-2' }}
          </td>
        </tr>

        <!-- Total Row -->
        <tr>
          <td colspan="1" 
              style="font-weight: bold; text-align: end; border: 1px solid #000; background-color: #f0f8ff;">
            Total:
          </td>
          <td colspan="1" 
              style="font-weight: bold; text-align: end; border: 1px solid #000; background-color: #f0f8ff;">
            {{ advtMonthwiseTotal | number: '1.2-2' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Action Buttons -->
  <div style="text-align: right; margin: 20px 0;">
    <button class="noPrint" mat-raised-button color="primary"
      (click)="exportExcel('Contract_InDetails_Report')" style="margin-right: 10px;">
      Export
    </button>

    <button class="noPrint" mat-raised-button color="primary"
      ngxPrint printSectionId="print-section" [useExistingCss]="true" style="margin-right: 10px;">
      Print
    </button>

    <button class="noPrint" mat-button mat-dialog-close>
      Close
    </button>
  </div>
</div>
